import { render, staticRenderFns } from "./PaginationOffset.vue?vue&type=template&id=3c4d8b2e&scoped=true&"
import script from "./PaginationOffset.vue?vue&type=script&lang=js&"
export * from "./PaginationOffset.vue?vue&type=script&lang=js&"
import style0 from "./PaginationOffset.vue?vue&type=style&index=0&id=3c4d8b2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4d8b2e",
  null
  
)

export default component.exports